export function countMinRequired(rule) {
  if (typeof rule === 'string') {
    return 1;
  }
  if (rule.and) {
    return rule.and.reduce((sum, item) => sum + countMinRequired(item), 0);
  }
  if (rule.or) {
    return Math.min(...rule.or.map((item) => countMinRequired(item)));
  }
  return 0;
}
export function renderRule(rule, t) {
  if (typeof rule === 'string') {
    return <li>{rule}</li>;
  }
  if (rule.and) {
    return (
      <div>
        <strong>{t('signup.all_listed_docs')}</strong>
        <ul>
          {rule.and.map((item, index) => (
            <li key={index} className='flex flex-row gap-0.5'>
              {`${index + 1}. `}
              {renderRule(item, t)}
            </li>
          ))}
        </ul>
      </div>
    );
  }
  if (rule.or) {
    return (
      <div>
        <strong>{t('signup.any_of_listed_docs')}</strong>
        <ul>
          {rule.or.map((item, index) => (
            <li key={index} className='flex flex-row gap-0.5'>
              {`${index + 1}. `}
              {renderRule(item, t)}
            </li>
          ))}
        </ul>
      </div>
    );
  }
  return null;
}
